import { PublicationStatus, StockStatus, SkinSeoulProductType } from '../models/ProductTypes';

export const getPublicationStatusColor = (status: PublicationStatus): any => {
  switch (status) {
    case PublicationStatus.PUBLISH:
      return 'dark';
    case PublicationStatus.DRAFT:
      return 'secondary';
    case PublicationStatus.PENDING:
      return 'info';
    case PublicationStatus.PRIVATE:
      return 'secondary';
    default:
      return 'light';
  }
};

export const getStockStatusColor = (status: StockStatus): any => {
  switch (status) {
    case StockStatus.IN_STOCK:
      return 'success';
    case StockStatus.OUT_OF_STOCK:
      return 'danger';
    default:
      return 'secondary';
  }
};

export const getProductTypeColor = (type: SkinSeoulProductType): any => {
  switch (type) {
    case SkinSeoulProductType.Variable:
      return 'primary'; // Purple - will be distinct from other badges
    case SkinSeoulProductType.Variation:
      return 'warning';
    case SkinSeoulProductType.Simple:
      return 'info';
    default:
      return 'secondary';
  }
};

export const getWaveColor = (wave: string | number) => {
  const colors: { [key: string]: string } = {
    manual: '#8E44AD', // Purple
    '1': '#E67E22', // Orange
    '2': '#9B59B6', // Violet
    '3': '#D35400', // Dark Orange/Brown
    '4': '#A569BD', // Light Purple
    '5': '#D35400', // Dark Orange/Brown
    '6': '#7D3C98', // Dark Purple
    '7': '#AF7AC5', // Lavender
  };
  const waveKey = String(wave);
  return {
    backgroundColor: colors[waveKey] || '#95A5A6',
    color: '#FFFFFF',
    border: 'none',
  };
};

// ID Badge border colors - used by IdBadge component
export const getIdBadgeBorderColor = (type: string): string => {
  const colors: Record<string, string> = {
    SKU: '#343a40', // Dark
    SPI: '#0073AA', // WordPress Blue (Ocean)
    GPI: '#eb3d48', // Red (Glowpick color)
    CPPI: '#145a24', // Darker Green
    CPII: '#145a24', // Darker Green
    CPVI: '#145a24', // Darker Green
  };
  return colors[type] || '#343a40';
};
